import { render, staticRenderFns } from "./LegalContract.vue?vue&type=template&id=04def538&scoped=true&"
import script from "./LegalContract.vue?vue&type=script&lang=js&"
export * from "./LegalContract.vue?vue&type=script&lang=js&"
import style0 from "./LegalContract.vue?vue&type=style&index=0&id=04def538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04def538",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
